
import Paintbucket from "../../../assets/duotone/Paintbucket.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function PaintbucketIcon({ className, dataTestid = "PaintbucketIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Paintbucket data-testid={dataTestid} className={classes} {...rest} />
  );
}
